import React, { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { TokenManager } from "../helpers/api_helper";

const SuperAdminProtected = (props: any) => {
  const isSuperAdmin = TokenManager.isSuperAdmin();
  const warned = useRef(false);

  useEffect(() => {
    if (!isSuperAdmin && !warned.current) {
      warned.current = true;
      toast.error("Super admin access required.");
    }
  }, [isSuperAdmin]);

  if (!isSuperAdmin) {
    return <Navigate to="/properties" replace />;
  }

  return <>{props.children}</>;
};

export default SuperAdminProtected;
